/** Persisted key for admin dashboard display timezone (User + API tabs). */
export const ADMIN_DASHBOARD_TIMEZONE_STORAGE_KEY = 'adminDashboardTimeZone';

/** Default: Malaysia Time */
export const DEFAULT_ADMIN_TIMEZONE = 'Asia/Kuala_Lumpur';

export const ADMIN_TIMEZONE_OPTIONS = [
  { value: 'Asia/Kuala_Lumpur', label: 'MYT (Malaysia)' },
  { value: 'Asia/Kolkata', label: 'IST (India)' },
] as const;

export function shortTzLabel(iana: string): string {
  if (iana === 'Asia/Kuala_Lumpur') return 'MYT';
  if (iana === 'Asia/Kolkata') return 'IST';
  return iana;
}

/** Format Unix seconds in an IANA timezone for admin tables. */
export function formatUnixInAdminTz(unixSeconds: number, timeZone: string): string {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(new Date(unixSeconds * 1000));
  } catch {
    return new Date(unixSeconds * 1000).toISOString().replace('T', ' ').slice(0, 19);
  }
}

/**
 * CSV column "Signup Date & Time (UTC)" — parse as UTC and show in selected zone.
 * Falls back to original string if parsing fails.
 */
export function parseUtcSignupStringToDisplay(s: string, timeZone: string): string {
  const t = s?.trim();
  if (!t) return '';
  const isoLike = t.includes('T') ? t : t.replace(' ', 'T');
  const withZ = /[zZ]|[+-]\d{2}:?\d{2}$/.test(isoLike) ? isoLike : `${isoLike}Z`;
  const ms = Date.parse(withZ);
  if (Number.isNaN(ms)) return t;
  return formatUnixInAdminTz(Math.floor(ms / 1000), timeZone);
}
